import PropTypes from 'prop-types';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import CheckCircleOutlined from '@ant-design/icons/CheckCircleOutlined';
import CloseCircleOutlined from '@ant-design/icons/CloseCircleOutlined';
import ClockCircleOutlined from '@ant-design/icons/ClockCircleOutlined';
import StopOutlined from '@ant-design/icons/StopOutlined';

import { approvalChipSx } from './tableChipStyles';

const CONFIG = {
  approved: { icon: CheckCircleOutlined, label: 'Approved' },
  pending: { icon: ClockCircleOutlined, label: 'Pending' },
  rejected: { icon: CloseCircleOutlined, label: 'Rejected' },
  suspended: { icon: StopOutlined, label: 'Suspended' }
};

export default function ApprovalStatusChip({ status }) {
  const key = String(status ?? 'pending').toLowerCase();
  const cfg = CONFIG[key] ?? CONFIG.pending;
  const Icon = cfg.icon;

  return (
    <Chip
      icon={
        <Box component="span" sx={{ display: 'inline-flex', color: 'inherit', fontSize: 14, lineHeight: 0 }}>
          <Icon />
        </Box>
      }
      label={cfg.label}
      size="small"
      sx={approvalChipSx(key)}
    />
  );
}

ApprovalStatusChip.propTypes = {
  status: PropTypes.string
};
